/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { CustomLabel } from 'modules/timesheet-labels/labelSchema';
import LabelOptionItem from '../OptionItem';
import { SearchFacetType, SuggestionItemProp } from '../type';
import { customLabelsTag } from './tag';
import makeCriteriaProvider from './makeCriteriaProvider';
import { getDetailsControl } from './CustomLabelFacetDetails';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(0)
  }
}));

const SuggestionItem: React.FC<SuggestionItemProp> = ({
  option
}: SuggestionItemProp) => {
  const classes = useStyles();
  return (
    <LabelOptionItem
      testId={option.id}
      value={option.label}
      classes={classes}
    />
  );
};

export const getCustomLabelFacet = (
  customLabels: CustomLabel[]
): SearchFacetType => ({
  makeCriteriaProvider: makeCriteriaProvider(customLabels),
  tag: customLabelsTag,
  DetailsControl: getDetailsControl(customLabels),
  SuggestionItem: SuggestionItem
});
